import React from "react";
import { Form, Input, InputNumber, Switch, Row, Col, Card, Typography } from "antd";
import { CalendarOutlined, HomeOutlined, KeyOutlined, UserOutlined } from "@ant-design/icons";

const { Title } = Typography;

interface BookingTabProps {
  form: any;
}

export const BookingTab: React.FC<BookingTabProps> = ({ form }) => {
  return (
    <div>
      <Title level={4}>
        <CalendarOutlined style={{ marginRight: '8px' }} />
        Buchungsdaten
      </Title>
      
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Card title="Buchungsinformationen" size="small">
            <Form.Item
              name={['booking', 'id']}
              label="Buchungs-ID"
              rules={[{ required: true, message: 'Bitte geben Sie eine Buchungs-ID ein' }]}
            >
              <Input prefix={<CalendarOutlined />} placeholder="z.B. BK2024-001" />
            </Form.Item>

            <Row gutter={8}>
              <Col span={12}>
                <Form.Item
                  name={['booking', 'checkIn']}
                  label="Check-in"
                  rules={[{ required: true, message: 'Bitte wählen Sie ein Check-in Datum' }]}
                >
                  <Input 
                    type="date" 
                    prefix={<CalendarOutlined />}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name={['booking', 'checkOut']}
                  label="Check-out"
                  rules={[{ required: true, message: 'Bitte wählen Sie ein Check-out Datum' }]}
                >
                  <Input 
                    type="date" 
                    prefix={<CalendarOutlined />}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Zimmerinformationen" size="small">
            <Row gutter={8}>
              <Col span={12}>
                <Form.Item
                  name={['booking', 'roomNumber']}
                  label="Zimmernummer"
                  rules={[{ required: true, message: 'Bitte geben Sie eine Zimmernummer ein' }]}
                >
                  <Input prefix={<HomeOutlined />} placeholder="z.B. 101" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name={['booking', 'roomType']}
                  label="Zimmertyp"
                  rules={[{ required: true, message: 'Bitte geben Sie einen Zimmertyp ein' }]}
                >
                  <Input placeholder="z.B. Suite, Standard" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name={['booking', 'doorCode']}
              label="Türcode"
              rules={[{ required: true, message: 'Bitte geben Sie einen Türcode ein' }]}
            >
              <Input prefix={<KeyOutlined />} placeholder="z.B. 4711" />
            </Form.Item>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
        <Col span={12}>
          <Card title="Gästeinformationen" size="small">
            <Form.Item
              name={['booking', 'numberOfGuests']}
              label="Anzahl Gäste"
              rules={[{ required: true, message: 'Bitte geben Sie die Anzahl der Gäste ein' }]}
            >
              <InputNumber 
                min={1} 
                max={10} 
                style={{ width: '100%' }} 
                prefix={<UserOutlined />}
              />
            </Form.Item>

            <Form.Item
              name={['booking', 'petsAllowed']}
              label="Haustiere erlaubt"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item
              name={['booking', 'numberOfPets']}
              label="Anzahl Haustiere"
              dependencies={['booking', 'petsAllowed']}
            >
              <InputNumber 
                min={0} 
                max={5} 
                style={{ width: '100%' }}
                disabled={!form.getFieldValue(['booking', 'petsAllowed'])}
              />
            </Form.Item>
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Zusätzliche Informationen" size="small">
            <Form.Item
              name={['booking', 'specialRequests']}
              label="Besondere Wünsche"
            >
              <Input.TextArea 
                rows={4} 
                placeholder="Besondere Anforderungen oder Wünsche der Gäste..."
              />
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </div>
  );
}; 